import { Grid, StyledCard } from "@rentiohq/web-shared/dist/components";
import styled from "@rentiohq/web-theme";

export const Wrapper = styled((props: any) => <Grid {...props} />)`
  ${StyledCard} {
    height: 100%;
  }
`;

// The dashboard's Page has no title, but its PageHeader still reserves 40px
// above the content (32px of padding and an empty 8px header), on top of the
// content's own 32px. The dashboard pulls its content up over that empty
// header, so the first card sits at the page's normal distance from the top
// bar instead of twice it.
const EMPTY_PAGE_HEADER_HEIGHT = 40;

// flow-root keeps the first grid's own negative margin inside this element, so
// it does not collapse with this one and swallow part of it.
export const Content = styled.div`
  display: flow-root;
  margin-top: -${EMPTY_PAGE_HEADER_HEIGHT}px;
`;
